import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from "chart.js";

@Component({
  selector: 'app-doughnut-chart-average-retention',
  templateUrl: './doughnut-chart-average-retention.component.html',
  styleUrls: ['./doughnut-chart-average-retention.component.css']
})
export class DoughnutChartAverageRetentionComponent implements OnInit, OnDestroy {
  //
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  title = "Ritenzione pazienti";
  destination = 'general-status';
  // ******************************************************************************************************************
  // inizializzazione per i doughnut charts sul numero di utenti per malattia
  // ******************************************************************************************************************
  public colorsOptions = [{
    backgroundColor: [
      '#ffc0cb',
      '#336699',
    ],
    hoverbackgroundColor: [
      '#c46200',
      '#214262',
    ]
  }];
  public doughnutChartOptions = {
    legend: {
      onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
        // tslint:disable-next-line:max-line-length
        if (legendItem.text.length > 0 && (legendItem.text === 'Donne' || legendItem.text === 'Uomini')) {
          this.setHoverVariable();
        } else {
          this.unsetHoverVariable();
        }
      },
      display: true,
      position: 'top',
      align: 'left',
      textDirection: 'ltr',
      labels: {
        usePointStyle: true,
        fontColor: '#006192',
        fontSize: 18,
        fontFamily: 'Helvetica',
      }
    },
    cutoutPercentage: 70,
    tooltips: {
      content: '{pathology}: {number}',
      backgroundColor: '#1c1c1c',
      titleColor: '#f0d7f7',
      bodyFontSize: 18,
      titleFontSize: 18,
      cornerRadius: 5,
      caretPadding: 10
    }
  };
  // hover
  isHovered = false;
  public totalPatientsD = 0;
  public totalEtaMedia = 0;
  public headElements = ['gender', 'number','media'];
  public elements: any = [
    {gender: '', number: ''},
    {gender: '', number: ''},
    {total: ''}
  ];
  public elementsD: any = [
    {gender: '', number: '', media: ''},
    {gender: '', number: '', media: ''},
    {total: ''}
  ];
  public doughnutChartLabels = ['Donne', 'Uomini'];
  public doughnutChartData = []; // sono i dati che vanno presi dal database tramite delle richieste
  public doughnutChartDataDoctor = []; // sono i dati che vanno presi dal database, riferiti ai pazienti del singolo medico
  public doughnutChartType = 'doughnut';
  public retentionTime: string;

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState); }

  ngOnInit(): void {
    this.subscription2 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievedata();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
  }

  retrievedata() {
    this.subscription1 = this.doctorService.getQuestionnairesTotalPatients().subscribe(
      data => {
        let keys = Object.keys(data);
        let values = Object.values(data);
        
        this.doughnutChartDataDoctor.push(values[0]);
        this.doughnutChartDataDoctor.push(values[1]);
        
        this.elementsD[0].gender = 'Donne';
        this.elementsD[0].number = values[0].toString();
        this.elementsD[1].gender = 'Uomini';
        this.elementsD[1].number = values[1].toString();
        this.totalPatientsD = +parseInt(values[0].toString());
        this.totalPatientsD += parseInt(values[1].toString());
        this.getEtaMedia();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  getEtaMedia() {
    this.subscription3 = this.doctorService.getEtaMediaGender().subscribe(
      data => {
        let values = Object.values(data);
        this.elementsD[0].media = values[1].toFixed(2).toString();
        this.elementsD[1].media = values[2].toFixed(2).toString();
        this.totalEtaMedia = parseFloat(values[0].toFixed(2).toString());
        this.retrieveAvgRetentionTime();     
      }
  )


  }

  retrieveAvgRetentionTime() {
    this.subscription3 = this.doctorService.getAvgRetentionTime().subscribe(
        data => {
          this.retentionTime = data.toString();//.replace(",",".");            
        }
    )
  }
  // set hovered variable of Never Logged
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable of Never Logged
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
}
